package one.healthium.log_weight.di

import one.healthium.log_weight.ui.internal.LogWeightViewModel
import org.koin.core.module.dsl.viewModelOf
import org.koin.dsl.module

val logWeightModule = module {
    viewModelOf(::LogWeightViewModel)
}